import { get } from "lodash-es";
import { getIn } from "formik";
import { reach } from "yup";

export const getValidationState = (errors, touched, { name }) => {
    const isFieldTouched = !!get(touched, name);
    const isFieldError = !!get(errors, name);
    return isFieldTouched && isFieldError ? "invalid" : "none";
};

export const getErrors = (errors, { name }) => {
    return get(errors, name);
};

function getParent(name, values) {
    if (name.indexOf(".") < 0) {
        return values;
    } else {
        const currentName = name.substr(0, name.lastIndexOf("."));
        return getIn(values, currentName);
    }
}

export const isRequired = (validationSchema, values, field) => {
    if (values == null) {
        throw new TypeError("Values cannot be null");
    }

    if (field == null) {
        throw new TypeError("field cannot be null");
    }

    const { name } = field;
    const currentValues = getParent(name, values);
    try {
        let schema = reach(validationSchema, name, values).resolve({ parent: currentValues });
        if (schema != null) {
            schema = schema.describe();
            if (schema.tests) {
                return !!schema.tests.find(({ name }) => name === "required");
            }
        }
        return false;
    } catch (err) {
        return false;
    }
};
